import { MainV3ApiBase } from './base';
import { ServiceAgreementKey } from './../../commonv3/types/serviceAgreements';

export const ServiceAgreementApis = {
    base() {
        return MainV3ApiBase.appendPath('service_agreements');
    },
    show(key: ServiceAgreementKey) {
        return this.base()
            .withId(key)
            .get();
    },
};
